import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";
import type {
  TenantDashboardOverviewResponse,
  TimeRange,
} from "../schemas/tenantDashboard";

/**
 * UC-005 David A&L soft dashboard query (Phase 23).
 *
 * Backend endpoint `/api/tenant/dashboard/overview?range=6M|12M|ALL` vrací
 * tenant-scoped overview — 3× stat totals, per-(month,plate) timeline,
 * per-SPZ breakdown, uzavřené měsíce.
 *
 * RLS izolace = backend per princip #6 (frontend NIKDY nepředpokládá scope).
 * Refetch onWindowFocus protože data se nemění často — admin reload manuálně.
 */

const KEY_OVERVIEW = (range: TimeRange) =>
  ["tenant", "dashboard", "overview", range] as const;

export function useTenantDashboardOverview(range: TimeRange) {
  return useQuery({
    queryKey: KEY_OVERVIEW(range),
    queryFn: () =>
      apiCall<TenantDashboardOverviewResponse>(
        `/api/tenant/dashboard/overview?range=${encodeURIComponent(range)}`,
      ),
    staleTime: 60_000,
  });
}

export const TENANT_DASHBOARD_QUERY_KEYS = {
  overview: KEY_OVERVIEW,
};
